import { render, staticRenderFns } from "./mingxi.vue?vue&type=template&id=22b1df2c&scoped=true&"
import script from "./mingxi.vue?vue&type=script&lang=js&"
export * from "./mingxi.vue?vue&type=script&lang=js&"
import style0 from "./mingxi.vue?vue&type=style&index=0&id=22b1df2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b1df2c",
  null
  
)

export default component.exports